module.exports = __webpack_public_path__ + "media/images/burnout-indicator-icon-61ffad9d4e63eda2f64fd0af92f50432.png";